import { Component, ElementRef, ViewChild, Input, EventEmitter, Output, NgModule, HostListener } from '@angular/core';
import { Translate } from 'src/shared/translate';
import { RequestService } from './requestService.service';
import { Platform } from '@ionic/angular';
import { MobileService } from './mobileLogin-api.service';
import { Geolocation, Position } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'OfflineModeWarning',
    templateUrl: './offlineMode.component.html',
    styleUrls: ['./translateElem.component.scss'],
})
export class OfflineModeWarning {
    @ViewChild('translateElement') elem;
    @ViewChild('ok') okElem;
    @ViewChild('cancel') closeElem;

    @Input() okName: string = "Ok";
    @Input() closeName: string = "Close";
    @Output() closeRequest = new EventEmitter<any>();
    @Output() okRequest = new EventEmitter<any>();
    offlineMode: boolean = false;
    constructor(
        private el: ElementRef,
        private requestService: RequestService,
        private plt: Platform,
        private mobileService: MobileService
    ) {
        this.requestService.offlineModeObservable.subscribe(value => {
            if (this.offlineMode != value) {
                if (value) this.elem.nativeElement.innerHTML = Translate.getTranslation("OfflineModeWarning");
                else this.elem.nativeElement.innerHTML = Translate.getTranslation("OnlineModeWarning");
                this.open();
            }
            this.offlineMode = value;
        });
    }

    ngAfterViewInit() {
        if (this.el.nativeElement.getAttribute('paramdata') !== undefined) {
            this.elem.nativeElement.innerHTML = Translate.languages[Translate.currentLanguage][this.el.nativeElement.getAttribute('paramdata')];
        }

        this.okElem.nativeElement.innerHTML = Translate.languages[Translate.currentLanguage][this.okName];
        this.closeElem.nativeElement.innerHTML = Translate.languages[Translate.currentLanguage][this.closeName];
        if (this.isOverflown(document.getElementById("smartText")) == false) {
            document.getElementById("smartText").style.display = "flex";
            document.getElementById("smartText").style.flexWrap = "wrap";
            document.getElementById("smartText").style.alignContent = "center";
            document.getElementById("smartText").style.justifyContent = "center";
            document.getElementById("smartText").style.textAlign = "center";
        }

        this.elem.nativeElement.innerHTML = Translate.languages[Translate.currentLanguage]['OnlineModeWarning'];
    }
    ionViewDidEnter() {
        this.elem.nativeElement.innerHTML = Translate.languages[Translate.currentLanguage]['OnlineModeWarning'];
    }
    alertGiven: boolean = false;

    open() {
        var modal = document.getElementById("offlineModal");
        modal.style.display = "block";
    }

    close(event?) {
        event.currentTarget.parentElement.parentElement.parentElement.style.display = "none";
        this.alertGiven = true;
        this.closeRequest.emit(null);
    }

    closeOk(event) {
        event.currentTarget.parentElement.parentElement.parentElement.style.display = "none";
        this.closeRequest.emit(null);
        this.okRequest.emit(null);
    }

    isOverflown(element) {
        return element.scrollHeight > element.clientHeight;
    }

    delayStr: String = "";
    getPingText() {
        this.delayStr = this.requestService.delayStr;
    }

    pingAgain() {
        this.requestService.pingAllowedDelay = parseInt((<HTMLInputElement>document.getElementById("pingDelay")).value);
        this.requestService.pingServer();
    }

    pos1: number = 0;
    pos2: number = 0;
    pos3: number = 0;
    pos4: number = 0;
    modalToMove: any;
    dragMouseDown(event) {
        event.preventDefault();
        this.modalToMove = event.currentTarget.parentElement;
        var mydiv = event.currentTarget.parentElement;
        mydiv.style.position = "absolute";
        this.pos3 = event.clientX;
        this.pos4 = event.clientY;
    }

    @HostListener('document:pointermove', ['$event'])
    onMouseMove(event) {
        this.pos1 = this.pos3 - event.clientX;
        this.pos2 = this.pos4 - event.clientY;
        this.pos3 = event.clientX;
        this.pos4 = event.clientY;
        if (this.modalToMove != null) {
            var mydiv = this.modalToMove;
            mydiv.style.top = (mydiv.offsetTop - this.pos2) + "px";
            mydiv.style.left = (mydiv.offsetLeft - this.pos1) + "px";
        }
    }

    @HostListener('document:pointerup', ['$event'])
    onMouseUp(event) {
        if ((this.plt.is('cordova') && event.type == "pointerout") || event.type == "pointerup") {
            this.modalToMove = null;
        }
    }

    closeDiv(event) {
        var mydiv = event.currentTarget.parentElement;
        mydiv.style.display = "none";
    }

    timeStr: string = "";
    async saveLocation() {
        try {
            const location = await this.getCurrentLocation();
            this.mobileService.saveLocation(true, location).then(data => {
                this.timeStr = data;
            });
        } catch (error: any) {
            console.error("Failed to get location:", error.message);
        }
    }

    async saveLocationOffline() {
        try {
            const location = await this.getCurrentLocation();
            this.mobileService.saveLocation(false, location).then(data => {
                this.timeStr = data;
            });
        } catch (error: any) {
            console.error("Failed to get location:", error.message);
        }
    }

    async getCurrentLocation(): Promise<GeolocationPosition | Position> {
        const platform = Capacitor.getPlatform();

        if (platform === 'ios' || platform === 'android') {
            // Capacitor native location
            return await Geolocation.getCurrentPosition({
                enableHighAccuracy: true,
                timeout: 6000,
                maximumAge: 0,
            });
        } else {
            // Web fallback
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0,
                });
            });
        }
    }



    syncCoordinates() {
        this.mobileService.syncWorkerCoordinates();
    }

    clearCacheCoords() {
        this.mobileService.clearWorkerCoordinates();
    }
}